import React, { useState } from 'react';

import BottomSheet from 'components/BottomSheet';
import useStoreTranslation from 'hooks/useStoreTranslation';
import { HotelDetailsCompleteResponse } from 'models/hotelDetailsComplete';

import SeeMoreHeader from '../SeeMoreHeader';
import { DetailCard, Info, InfoContainer } from './styles';

interface Props {
  details: HotelDetailsCompleteResponse;
}

const AboutHotel = ({ details }: Props) => {
  const { t } = useStoreTranslation();
  const [seeMore, setSeeMore] = useState(false);

  const toggleSeeMore = () => setSeeMore(!seeMore);

  return (
    <>
      <DetailCard>
        <SeeMoreHeader title={t('hotelDetails.aboutHotel')} seeMore={seeMore} onToggleSeeMore={toggleSeeMore} />

        <InfoContainer>
          <Info>{details.shortDescription}</Info>
        </InfoContainer>
      </DetailCard>

      <BottomSheet modal title={t('hotelDetails.aboutHotel')} show={seeMore} onClose={toggleSeeMore}>
        <Info $seeMore>{details.shortDescription}</Info>
      </BottomSheet>
    </>
  );
};

export default AboutHotel;
